import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "connect-modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  href: "https://github.com/bfh-pcdh/enerki/blob/main/SETUP.md",
  target: "_blank"
}
const _hoisted_8 = { class: "button-container" }
const _hoisted_9 = ["disabled", "title"]
const _hoisted_10 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "background" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.i18n('CONNECT_TITLE')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString($setup.i18n('CONNECT_NOTCONNECTED')), 1 /* TEXT */),
            _createElementVNode("p", null, [
              _createElementVNode("a", _hoisted_7, _toDisplayString($setup.i18n('CONNECT_INSTRUCTIONS')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createCommentVNode(" button \n              @click=\"connect('heartRate')\"\n              :disabled=\"!store.heartRate.stickAvailable()\"\n              class=\"connect-button\">\n              Pulssensor verbinden\n            </button"),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.connect('power'))),
                class: "connect-button",
                disabled: !$setup.store.power.stickAvailable(),
                title: $setup.i18n('CONNECT_POWERMETER_TOOLTIP')
              }, _toDisplayString($setup.i18n('CONNECT_POWERMETER')), 9 /* TEXT, PROPS */, _hoisted_9),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.connect('debug'))),
                class: "connect-button",
                title: $setup.i18n('CONNECT_DEBUG_TOOLTIP')
              }, _toDisplayString($setup.i18n('CONNECT_DEBUG')), 9 /* TEXT, PROPS */, _hoisted_10)
            ])
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}